import script from "./TableExpandableRows.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./TableExpandableRows.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./TableExpandableRows.vue?vue&type=style&index=0&id=756fbd00&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-756fbd00"]])

export default __exports__